import { mapActions, mapState } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';
import { MODALS } from '@/components/app/app-modals/app-modals';
import recaptcha from '@/services/recaptcha';

const CAPTCHA_FIELD = 'g-recaptcha-response';

export default {
  mixins: [
    formMixin,
  ],
  data() {
    return {
      // attempt counter for v2 fallback rerenders
      attempt: 1,
      fields: {
        email: null,
      },
      // Pending payload for v2 fallback retry
      pendingPayload: null,
    };
  },
  validations: {
    fields: {
      email: validators.email,
    },
  },
  computed: {
    ...mapState('app', ['systemEmails']),
    resetUrl() {
      return `${window.location.protocol}//${window.location.host}/account/password/reset/`;
    },
    resetButtonDisabled() {
      return this.invalidOrDisabled;
    },
  },
  methods: {
    ...mapActions('user', ['forgotPassword']),
    ...mapActions('popup', ['setCurrentPopup', 'setCurrentPopupOptions']),
    ...mapActions('notifications', ['setSuccessSideNotification']),
    async onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        try {
          // Step 1: Get invisible v3 token
          const v3Token = await recaptcha.executeV3('forgot_password');

          const payload = {
            [CAPTCHA_FIELD]: v3Token,
            'recaptcha-version': 'v3',
            email: this.fields.email,
            url: this.resetUrl,
          };

          this.forgotPassword(payload)
            .then((data) => {
              this.formEnable();
              this.setSuccessSideNotification(data);
              this.setCurrentPopup();
            })
            .catch((error) => {
              // Step 2: Check if v3 failed and v2 challenge is needed
              if (recaptcha.isV3ScoreFailure(error)) {
                this.pendingPayload = payload;
                this.attempt += 1;
                this.setCurrentPopup(MODALS.RECAPTCHA_CHALLENGE);
                this.setCurrentPopupOptions({
                  attempt: this.attempt,
                  onVerified: this.onRecaptchaV2Verified,
                });
                this.formEnable();
                return;
              }

              this.attempt += 1;
              this.formHandleErrors(error);
            });
        } catch (err) {
          this.formEnable();
          this.formHandleErrors(err);
        }
      }
    },
    onRecaptchaV2Verified(v2Token) {
      // Called when user completes v2 challenge in modal
      // Don't switch to forgotten modal yet - keep reCAPTCHA visible during API call

      const payload = {
        ...this.pendingPayload,
        [CAPTCHA_FIELD]: v2Token,
        'recaptcha-version': 'v2',
      };

      this.forgotPassword(payload)
        .then((data) => {
          this.formEnable();
          this.setSuccessSideNotification(data);
          this.setCurrentPopup();
        })
        .catch((error) => {
          // On error, switch back to forgotten modal to show error
          this.setCurrentPopup(MODALS.FORGOTTEN);
          this.attempt += 1;
          this.formHandleErrors(error);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-forgotten/account-forgotten.js